import React from "react";
import BaseGrid from "Components/Fragment/BaseGrid";

const EmptyFilterResult = ({ label }) => {
  return (
    <BaseGrid>
      <div className="empty-filter-result">
        <h2>{label}</h2>
      </div>
    </BaseGrid>
  );
};

export default EmptyFilterResult;
